import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * TagsMore component
 */
export default class TagsMore extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'TagsMore',
    refs: ['btn', 'container'],
  };

  isClosed = true;

  /**
   * mounted
   */
  mounted() {
    const isInvisible = this.$refs.container.offsetHeight < this.$refs.container.scrollHeight;
    toggleClass(this.$el, 'is-overflowing', isInvisible);
    this.$refs.btn.style.visibility = isInvisible ? 'visible' : 'hidden';
  }

  /**
   * onBtnClick
   */
  onBtnClick() {
    this.isClosed = !this.isClosed;
    toggleClass(this.$refs.container, ['h-[1.95rem]', 'overflow-hidden'], this.isClosed);
    toggleClass(this.$el, 'is-open', !this.isClosed);
    this.$refs.btn.setAttribute('aria-expanded', String(!this.isClosed));

    const { labelClosed, labelOpen } = this.$refs.btn.dataset;
    const label = this.isClosed ? labelClosed : labelOpen;
    if (label) {
      this.$refs.btn.setAttribute('aria-label', label);
    }

    if (this.isClosed) {
      if (this.$el.contains(document.activeElement)) {
        this.$refs.btn.focus();
      }
    } else {
      if (!this.$refs.container.hasAttribute('tabindex')) {
        this.$refs.container.setAttribute('tabindex', '-1');
      }
      this.$refs.container.focus();
    }
  }
}
